import { useCallback } from 'react';

import { useObserver, useSetDataCallback } from '../state';

export const useGetUserConfirmation = (): ((message: string, callback: (result: boolean) => void) => void) => {
  const observer = useObserver();
  const setData = useSetDataCallback();

  return useCallback(
    (message: string, callback: (result: boolean) => void) => {
      setData({ open: true, message });

      observer.subscribe((result, unsubscribe) => {
        setData({ open: false, message });
        callback(result);
        unsubscribe();
      });
    },
    [observer, setData]
  );
};
